import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  BookOpen,
  Users,
  UserCircle,
  Brain,
  Languages,
  Trophy,
  AlertTriangle,
  UserCheck,
  Calendar,
  Scale
} from 'lucide-react';

const StudentSidebar = () => {
  const menuItems = [
    {
      section: 'Asosiy',
      items: [
        { path: '/student', icon: LayoutDashboard, label: 'Bosh sahifa', exact: true },
      ]
    },
    {
      section: "Ta'lim",
      items: [
        { path: '/student/subjects', icon: BookOpen, label: 'Fanlarim' },
        { path: '/student/groupmates', icon: Users, label: 'Guruhim' },
        { path: '/student/clubs', icon: Trophy, label: "To'garaklar" },
        { path: '/student/events', icon: Calendar, label: "Tadbirlar" },
      ]
    },
    {
      section: 'Testlar',
      items: [
        { path: '/student/temperament', icon: Brain, label: 'Temperament' },
        { path: '/student/suicide-test', icon: Brain, label: 'Psixologik test' },
        { path: '/student/language', icon: Languages, label: 'Til bilish' },
      ]
    },
    {
      section: 'Xabarlar',
      items: [
        { path: '/student/leadership', icon: UserCheck, label: 'Rahbariyat' },
        { path: '/student/corruption', icon: AlertTriangle, label: 'Korrupsiya' },
        { path: '/student/regulations', icon: Scale, label: 'Nizom va hukumat qarorlari' },
      ]
    },
    {
      section: 'Profil',
      items: [
        { path: '/student/profile', icon: UserCircle, label: 'Profilim' },
      ]
    }
  ];

  return (
    <aside className="sidebar student-sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <div className="sidebar-logo-icon">
            <img src="/logo.png" alt="BXTT" />
          </div>
          <div>
            <h2>BXTT</h2>
            <span>Talaba</span>
          </div>
        </div>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((section, idx) => (
          <div key={idx} className="nav-section">
            <div className="nav-section-title">{section.section}</div>
            {section.items.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.exact}
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              >
                <item.icon size={20} />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </nav>
    </aside>
  );
};

export default StudentSidebar;
